<div class="skeleton-loader chart">
    <div class='axes'>
        <div class="y-axis">
            <div class="x-axis"></div>
            <div class="doughnut-box">
                <div class="doughnut">
                    <div class="outer-ring">
                        <div class="section"></div>
                        <div class="section"></div>
                        <div class="section"></div>
                        <div class="section"></div>
                        
                        <div class="inner-ring">
                            <div class="section"></div>
                            <div class="section"></div>
                        </div>
                    </div>
                    <div class="doughnut-hole"></div>
                </div>
            </div>            
        </div>
    </div>
</div>
<div class="skeleton-loader legend">
    <div class="legend-wrapper">
        @for (k of legendCountArray; track k) {
        <div class="legend-item-wrapper">
            <div class="legend-item"></div>
            <div class="legend-label"></div>
        </div>
        }
    </div>
</div>
